import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import * as moment from "moment";
import { useNavigate } from "react-router-dom";
import { Image, Anchor } from "hesus-ui-kit";
import disputeExistIcon from "@icons/dispute-exist.svg";
import noDisputeIcon from "@icons/no-dispute.svg";
import planningIcon from "@icons/ic-planning.svg";
import greySummaryIcon from "@icons/supplier-sumarry-grey.svg";
import blueSummaryIcon from "@icons/supplier-sumarry-blue.svg";
import darkBlueSummaryIcon from "@icons/supplier-sumarry-blue-dark.svg";
import darkBlueInvoicedIcon from "@icons/ic-invoiced.svg";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import {
  GridRow,
  GridSubItem,
  SolutionIdLink,
} from "../../GeneralPlanningList.styled";
import "../../GeneralPlanningList.scss";

const SiteListing = ({
  t,
  siteId,
  planningData,
  onSolutionIdClick,
  onDisputeAdd,
  onDisputeView,
  page,
  planingStatus,
  summaryAction,
  summaryByService,
}) => {
  const history = useNavigate();

  if (!planningData || !Array.isArray(planningData)) {
    return null;
  }

  const onPlanning = (id) => {
    history(`/planning/${id}/suppliers`);
  };

  const getSummaryStatus = (status) => {
    let imageSrc = greySummaryIcon;
    if (status === 1) {
      imageSrc = blueSummaryIcon;
    }
    if (status === 2) {
      imageSrc = darkBlueSummaryIcon;
    }
    if (status === 3) {
      imageSrc = darkBlueInvoicedIcon;
    }
    return imageSrc;
  };

  const getSummaryTitle = (status) => {
    let summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_NO_SUMMARY";
    if (status === 1) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_SUMMARY";
    }
    if (status === 2) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_COMPLETED_SUMMARY";
    }
    if (status === 3) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_INVOICED_SUMMARY";
    }
    return summaryImageTitle;
  };

  return planningData.flatMap((planning) => {
    if (planingStatus && !planning.service.hesusService.needSupplierPlanning) {
      return null;
    }
    return (
      <React.Fragment
        key={`daily-panning-lines-${planning?.clientOrderItemId}`}
      >
        {planning?.planningLines?.length > 0 &&
          planning?.planningLines?.map((line, lineIndex) => {
            return (
              <React.Fragment key={`quote-item-${line?.id}-${lineIndex}`}>
                <GridRow
                  key={`planning-orders-site-${line.id}-${lineIndex}`}
                  column={
                    page === "site"
                      ? "9% 22% 20% 20% 5% 5% 7% 6% 6%"
                      : page === "daily"
                      ? "15% 23% 20% 20% 5% 5% 5% 7%"
                      : "6% 16% 21% 21% 21% 5% 5% 5%"
                  }
                  marginBottom="0px"
                  gap="1px"
                  borderLeft="2px solid #767676"
                  borderBottom="2px solid #767676"
                  borderRight="2px solid #767676"
                >
                  {page === "site" && (
                    <GridSubItem
                      color="#0A4986"
                      fontStyle="normal"
                      padding="5px 5px 0px 10px"
                      fontWeight="700"
                      textAlign="center"
                      verticalAlign="middle"
                      borderRight="2px solid rgb(118, 118, 118)"
                    >
                      {getDateFormat(planning.planningDate, "YYYY-MM-DD")}
                    </GridSubItem>
                  )}
                  {page === "daily" && (
                    <GridRow
                      borderRight="2px solid rgb(118, 118, 118)"
                      gap="0rem"
                    >
                      <GridSubItem
                        color="#0A4986"
                        padding="5px 5px 0px 10px"
                        fontWeight="700"
                        fontSize="16px"
                        alignContent="none"
                      >
                        <Anchor
                          className="planning-list__link"
                          url={`/site/view/${planning?.site?.id}/general-info`}
                          target="_blank"
                        >
                          {` #${planning?.site?.id}`}
                        </Anchor>
                        {` - ${planning?.site?.name}`}
                      </GridSubItem>
                      <GridSubItem
                        fontWeight="400"
                        fontSize="16px"
                        color="#474747"
                        fontStyle="italic"
                        padding="0px 5px 5px 10px"
                        alignContent="none"
                      >
                        {planning?.site?.company}
                      </GridSubItem>
                    </GridRow>
                  )}
                  {page === "global" && (
                    <GridRow
                      gap="0rem"
                      borderRight="2px solid rgb(118, 118, 118)"
                      column="1fr auto"
                    >
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        padding="5px 5px 5px 10px"
                      >
                        {line.lineGroupId}
                      </GridSubItem>
                    </GridRow>
                  )}
                  <GridRow
                    gap="0rem"
                    borderRight="2px solid rgb(118, 118, 118)"
                    column="1fr auto"
                  >
                    <GridRow gap="0rem">
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        padding="5px 5px 5px 10px"
                      >
                        {planning?.service?.hesusService.name}
                      </GridSubItem>
                      <GridSubItem
                        fontWeight="400"
                        fontSize="16px"
                        color="#474747"
                        fontStyle="italic"
                        padding="5px 5px 5px 10px"
                        alignContent="none"
                      >
                        {planning?.service?.hesusService.needProduct &&
                          planning?.service?.product.name}
                        {planning?.service?.hesusService.needProduct &&
                          planning?.service?.hesusService.needTransport &&
                          " - "}
                        {planning?.service?.hesusService.needTransport &&
                          planning?.service?.transport.name}
                      </GridSubItem>
                    </GridRow>
                    <GridSubItem
                      fontWeight="700"
                      fontSize="16px"
                      textAlign="right"
                      color="#474747"
                    >
                      {renderPriceWithCurrency(
                        addSpace(
                          getConvertedPrice(
                            planning?.service?.quoteServiceCurrency?.id,
                            planning?.service?.sellingPrice,
                            planning?.clientOrder?.exchangeRates
                          )
                        ),
                        t(line?.unit),
                        planning?.service?.quoteCurrency?.symbol,
                        planning?.service?.quoteCurrency?.position
                      )}
                    </GridSubItem>
                  </GridRow>

                  <GridRow>
                    {planning?.service?.hesusService?.needCarrier &&
                      (!planning?.service?.hesusService?.needCombination ||
                        (planning?.service?.hesusService?.needCombination &&
                          planning?.service?.hesusService
                            .needCombinationCenter)) && (
                        <GridRow column="1fr auto">
                          <GridRow gap="0rem">
                            <GridSubItem
                              fontWeight="700"
                              fontSize="16px"
                              padding="0px 5px 0px 10px"
                            >
                              {line.haulage?.company?.name}
                            </GridSubItem>
                            <GridSubItem
                              fontWeight="400"
                              fontSize="16px"
                              color="#474747"
                              fontStyle="italic"
                              padding="0px 5px 5px 10px"
                              alignContent="none"
                            >
                              {line.haulage?.transport?.name}
                            </GridSubItem>
                          </GridRow>
                          <GridSubItem
                            fontWeight="700"
                            fontSize="16px"
                            textAlign="right"
                            color="#474747"
                          >
                            {renderPriceWithCurrency(
                              addSpace(
                                getConvertedPrice(
                                  planning?.service?.quoteServiceCurrency?.id,
                                  line?.haulage?.purchasePrice,
                                  planning?.clientOrder?.exchangeRates
                                )
                              ),
                              t(line?.haulage?.purchaseUnit),
                              line?.haulage?.currency?.symbol,
                              line?.haulage?.currency?.position
                            )}
                          </GridSubItem>
                        </GridRow>
                      )}
                  </GridRow>

                  <GridRow borderLeft="2px solid rgb(118, 118, 118)">
                    {planning?.service?.hesusService?.needCenter &&
                      (!planning?.service?.hesusService?.needCombination ||
                        (planning?.service?.hesusService?.needCombination &&
                          planning?.service.hesusService
                            ?.needCombinationCarrier)) && (
                        <GridRow column="1fr auto">
                          <GridRow gap="0rem">
                            <GridSubItem
                              fontWeight="700"
                              fontSize="16px"
                              padding="0px 5px 0px 10px"
                            >
                              <SolutionIdLink
                                onClick={() =>
                                  onSolutionIdClick(line.solution.solutionId)
                                }
                              >
                                #{line.solution.solutionId}
                              </SolutionIdLink>{" "}
                              - [ {line.solution.centre?.supplierName}] -{" "}
                              {line.solution.centre?.name}
                            </GridSubItem>
                            <GridSubItem
                              fontWeight="400"
                              fontSize="16px"
                              color="#474747"
                              fontStyle="italic"
                              padding="0px 5px 5px 10px"
                              alignContent="none"
                            >
                              {line.solution.product?.name}
                            </GridSubItem>
                          </GridRow>
                          <GridSubItem
                            fontWeight="700"
                            fontSize="16px"
                            textAlign="right"
                            color="#474747"
                          >
                            {renderPriceWithCurrency(
                              addSpace(
                                getConvertedPrice(
                                  line?.solution?.currency?.id,
                                  line?.solution?.purchasePrice,
                                  planning?.clientOrder?.exchangeRates
                                )
                              ),
                              t(line?.solution?.purchaseUnit),
                              planning?.service?.quoteCurrency?.symbol,
                              planning?.service?.quoteCurrency?.position
                            )}
                          </GridSubItem>
                        </GridRow>
                      )}
                  </GridRow>

                  <GridSubItem
                    fontWeight="700"
                    fontStyle="normal"
                    fontSize="16px"
                    textAlign="center"
                    color="#0A4986"
                    borderLeft="2px solid #767676"
                  >
                    {planning?.service?.hesusService?.needSupplierPlanning
                      ? `${line.quantity} ${t(line.unit)}`
                      : t("SITE_NOT_PLANNED")}
                    {!planning?.service?.hesusService?.needSupplierPlanning
                      ? `${planning?.quantity} ${t(planning?.unit)}`
                      : ""}
                  </GridSubItem>

                  {siteId && (
                    <GridSubItem
                      fontWeight="700"
                      fontStyle="normal"
                      fontSize="16px"
                      textAlign="center"
                      color="#0A4986"
                      borderLeft="2px solid #767676"
                    >
                      -
                    </GridSubItem>
                  )}

                  <GridSubItem
                    fontWeight="700"
                    fontStyle="normal"
                    fontSize="16px"
                    textAlign="right"
                    color="#0A4986"
                    borderLeft="2px solid #767676"
                  >
                    {planning?.service?.hesusService?.needSupplierPlanning
                      ? getConvertedPrice(
                          line?.solution?.currency?.id,
                          line.turnover,
                          planning?.clientOrder?.exchangeRates
                        )
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                          .padEnd(10, "")
                      : "-"}
                    {!planning?.service?.hesusService?.needSupplierPlanning &&
                      getConvertedPrice(
                        planning?.solution?.currency?.id,
                        planning?.estimatedTurnover,
                        planning?.clientOrder?.exchangeRates
                      )
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                        .padEnd(10, "")}{" "}
                    {planning?.service?.quoteCurrency?.symbol}
                  </GridSubItem>

                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    textAlign="center"
                    padding="5px 5px 0px 10px"
                    borderLeft="2px solid #767676"
                    color={
                      // eslint-disable-next-line no-nested-ternary
                      line.marginRate >= 12
                        ? "#0A4986"
                        : line.marginRate <= 6
                        ? "#E83F1E"
                        : "#F08046"
                    }
                  >
                    {parseFloat(line.marginRate).toFixed(2)}%
                  </GridSubItem>

                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    textAlign="center"
                    padding="5px 5px 0px 10px"
                    borderLeft="2px solid #767676"
                    color={
                      // eslint-disable-next-line no-nested-ternary
                      line.marginRate >= 12
                        ? "#0A4986"
                        : line.marginRate <= 6
                        ? "#E83F1E"
                        : "#F08046"
                    }
                  >
                    {parseInt(line?.disputeCount, 10) > 0 && (
                      <Image
                        src={disputeExistIcon}
                        className="planning-list__general-planning-site-image-icon"
                        onClick={() =>
                          onDisputeView(
                            line?.lineGroupId,
                            page == "daily" ? planning.site.id : siteId
                          )
                        }
                        alt={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
                        title={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
                      />
                    )}
                    {parseInt(line?.disputeCount, 10) === 0 && (
                      <Image
                        src={noDisputeIcon}
                        className="planning-list__general-planning-site-image-icon"
                        onClick={() =>
                          onDisputeAdd(
                            line?.lineGroupId,
                            page == "daily" ? planning.site.id : siteId
                          )
                        }
                        alt={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
                        title={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
                      />
                    )}
                    {page === "daily" && (
                      <>
                        {planning?.service?.hesusService
                          ?.needSupplierPlanning && (
                          <Image
                            src={getSummaryStatus(line.summaryStatus)}
                            className="planning-list__general-planning-site-image-icon"
                            onClick={() =>
                              summaryByService(
                                line.summaryStatus,
                                "",
                                planning?.clientOrderItemId,
                                planning?.site?.id,
                                line?.lineGroupId,
                                planning?.service?.hesusService,
                                line?.haulage?.companyInfo,
                                line?.solution?.centreInfo
                              )
                            }
                            alt={t(getSummaryTitle(line.summaryStatus))}
                            title={t(getSummaryTitle(line.summaryStatus))}
                          />
                        )}
                        {!planning?.service?.hesusService
                          ?.needSupplierPlanning && (
                          <Image
                            src={getSummaryStatus(planning.summaryStatus)}
                            className="planning-list__general-planning-site-image-icon"
                            onClick={() =>
                              summaryAction(
                                planning.summaryStatus,
                                "",
                                planning?.clientOrderItemId,
                                planning?.site?.id
                              )
                            }
                            alt={t(getSummaryTitle(planning.summaryStatus))}
                            title={t(getSummaryTitle(planning.summaryStatus))}
                          />
                        )}
                      </>
                    )}
                  </GridSubItem>
                </GridRow>
              </React.Fragment>
            );
          })}
        {(planning?.planningLines?.length === 0 ||
          planning?.planningLines === null) && (
          <React.Fragment
            key={`quote-item-${planning?.clientOrderId}-${planning?.clientOrderItemId}`}
          >
            <GridRow
              key={`planning-orders-site-${planning?.clientOrderId}-${planning?.clientOrderItemId}`}
              column={
                page === "site"
                  ? "9% 22% 20% 20% 5% 5% 7% 6% 6%"
                  : page === "daily"
                  ? "15% 23% 20% 20% 5% 5% 5% 7%"
                  : "6% 16% 21% 21% 21% 5% 5% 5%"
              }
              marginBottom="0px"
              gap="1px"
              borderLeft="2px solid #767676"
              borderBottom="2px solid #767676"
              borderRight="2px solid #767676"
            >
              {page === "site" && (
                <GridSubItem
                  color="#0A4986"
                  fontStyle="normal"
                  padding="5px 5px 0px 10px"
                  fontWeight="700"
                  textAlign="center"
                  verticalAlign="middle"
                  borderRight="2px solid rgb(118, 118, 118)"
                >
                  {moment(planning.planningDate, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                  )}
                </GridSubItem>
              )}
              {page === "daily" && (
                <GridRow borderRight="2px solid rgb(118, 118, 118)" gap="0rem">
                  <GridSubItem
                    color="#0A4986"
                    padding="5px 5px 0px 10px"
                    fontWeight="700"
                    fontSize="16px"
                    alignContent="none"
                  >
                    <Anchor
                      lassName="planning-list__link"
                      target="_blank"
                      url={`/site/view/${planning?.site?.id}/general-info`}
                    >
                      {` #${planning?.site?.id}`}
                    </Anchor>
                    {` - ${planning?.site?.name}`}
                  </GridSubItem>
                  <GridSubItem
                    fontWeight="400"
                    fontSize="16px"
                    color="#474747"
                    fontStyle="italic"
                    padding="0px 5px 5px 10px"
                    alignContent="none"
                  >
                    {planning?.site?.company}
                  </GridSubItem>
                </GridRow>
              )}
              {page !== "daily" && page !== "site" && (
                <GridRow borderRight="2px solid rgb(118, 118, 118)"></GridRow>
              )}
              <GridRow
                gap="0rem"
                borderRight="2px solid rgb(118, 118, 118)"
                column="1fr auto"
              >
                <GridRow gap="0rem">
                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    padding="5px 5px 5px 10px"
                  >
                    {planning?.service?.hesusService.name}
                  </GridSubItem>
                  <GridSubItem
                    fontWeight="400"
                    fontSize="16px"
                    color="#474747"
                    fontStyle="italic"
                    padding="5px 5px 5px 10px"
                    alignContent="none"
                  >
                    {planning?.service?.hesusService.needProduct &&
                      planning?.service?.product.name}
                    {planning?.service?.hesusService.needProduct &&
                      planning?.service?.hesusService.needTransport &&
                      " - "}
                    {planning?.service?.hesusService.needTransport &&
                      planning?.service?.transport.name}
                  </GridSubItem>
                </GridRow>
                <GridSubItem
                  fontWeight="700"
                  fontSize="16px"
                  textAlign="right"
                  color="#474747"
                >
                  {renderPriceWithCurrency(
                    addSpace(
                      getConvertedPrice(
                        planning?.service?.quoteServiceCurrency?.id,
                        planning?.service?.sellingPrice,
                        planning?.clientOrder?.exchangeRates
                      )
                    ),
                    t(planning?.unit),
                    planning?.service?.quoteCurrency?.symbol,
                    planning?.service?.quoteCurrency?.position
                  )}
                </GridSubItem>
              </GridRow>

              <GridRow></GridRow>

              <GridRow borderLeft="2px solid rgb(118, 118, 118)"></GridRow>

              <GridSubItem
                fontWeight="700"
                fontStyle="normal"
                fontSize="16px"
                textAlign="center"
                color="#0A4986"
                borderLeft="2px solid #767676"
              >
                {planning?.service?.hesusService?.needSupplierPlanning
                  ? t("SITE_NOT_PLANNED")
                  : `${planning?.quantity} ${t(planning?.unit)}`}
              </GridSubItem>

              {siteId && (
                <GridSubItem
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                  color="#0A4986"
                  borderLeft="2px solid #767676"
                >
                  -
                </GridSubItem>
              )}

              <GridSubItem
                fontWeight="700"
                fontStyle="normal"
                fontSize="16px"
                textAlign="right"
                color="#0A4986"
                borderLeft="2px solid #767676"
              >
                {planning?.service?.hesusService?.needSupplierPlanning
                  ? "-"
                  : getConvertedPrice(
                      planning?.solution?.currency?.id,
                      planning?.estimatedTurnover,
                      planning?.clientOrder?.exchangeRates
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                      .padEnd(10, "")}{" "}
                {planning?.service?.quoteCurrency?.symbol}
              </GridSubItem>

              <GridSubItem
                fontWeight="700"
                fontSize="16px"
                textAlign="center"
                padding="5px 5px 0px 10px"
                borderLeft="2px solid #767676"
                color={
                  // eslint-disable-next-line no-nested-ternary
                  planning.margin >= 12
                    ? "#0A4986"
                    : planning.margin <= 6
                    ? "#E83F1E"
                    : "#F08046"
                }
              >
                {planning.service.hesusService.needSupplierPlanning
                  ? `- %`
                  : planning.service.margin
                  ? parseFloat(planning.service.margin).toFixed(2) + `%`
                  : ""}
              </GridSubItem>

              <GridSubItem
                fontWeight="700"
                fontSize="16px"
                textAlign="center"
                padding="5px 5px 0px 10px"
                borderLeft="2px solid #767676"
              >
                {planning?.service?.hesusService?.needSupplierPlanning && (
                  <Image
                    src={planningIcon}
                    className="planning-list__general-planning-site-image-icon"
                    onClick={() => onPlanning(planning?.clientOrderId)}
                    alt={t("CLIENT_ORDER_SUPPLIER_PLANNING_TOOLTIP")}
                    title={t("CLIENT_ORDER_SUPPLIER_PLANNING_TOOLTIP")}
                  />
                )}
                {page === "daily" && (
                  <>
                    {!planning?.service?.hesusService?.needSupplierPlanning && (
                      <Image
                        src={getSummaryStatus(planning.summaryStatus)}
                        className="planning-list__general-planning-site-image-icon"
                        onClick={() =>
                          summaryAction(
                            planning.summaryStatus,
                            "",
                            planning?.clientOrderItemId,
                            planning?.site?.id
                          )
                        }
                        alt={t(getSummaryTitle(planning.summaryStatus))}
                        title={t(getSummaryTitle(planning.summaryStatus))}
                      />
                    )}
                  </>
                )}
              </GridSubItem>
            </GridRow>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  });
};

SiteListing.propTypes = {
  t: PropTypes.func.isRequired,
  planningData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSolutionIdClick: PropTypes.func.isRequired,
};

SiteListing.defaultProps = {};

export default withTranslation()(SiteListing);
